import { useTranslation } from 'react-i18next';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Helmet } from 'react-helmet-async';
import { useMenu } from '../../hooks/useMenu';
import { HeadingSubtitle } from '../../components/Heading';
import useStepPost from '../../hooks/useStepPost';
import OnBoardingContainer from '../../components/OnBoarding/OnBoardingContainer';
import Paragraph from '../../components/Paragraph/Paragraph';
import OnBoardingCta from '../../components/OnBoarding/OnBoardingCta';
import themeColors from '../../assets/styles/themeColors';
import useGtmAddressDoneHook from '../../util/hooks/useGtmAddressDoneHook';
import { REGISTRATION_FLOW_TYPE } from '../../constants/sessionStorage';
import { retrieveFromSessionStorage } from '../../util/helpers/sessionStorageHelper';
import { selectSettings } from '../../store/selectors/settingsSelectors';
import SaveAndCloseModal from '../../components/Modals/SaveAndCloseModal/SaveAndCloseModal';

const AddressDone = () => {
  const { t } = useTranslation();
  const { activeMenu, activeItem } = useMenu();
  const { onSuccess } = useStepPost({ nextPath: activeItem?.nextPath });
  const { gtmAddressDoneHook } = useGtmAddressDoneHook();
  const isAipFlow =
    retrieveFromSessionStorage(REGISTRATION_FLOW_TYPE) === 'Aip';
  const { BrokerName } = useSelector(selectSettings);
  const [eventType, setEventType] = useState('NoForm');
  const [saveAndCloseModalOpen, setSaveAndCloseModalOpen] = useState(false);

  useEffect(() => {
    if (isAipFlow) {
      gtmAddressDoneHook();
    }
  }, [isAipFlow]); // eslint-disable-line

  return (
    <OnBoardingContainer
      activeMenu={activeMenu}
      activeItem={activeItem}
      previousPath={activeItem?.previousPath}
      setEventType={setEventType}
      eventType={eventType}
      setSaveAndCloseModalOpen={setSaveAndCloseModalOpen}
    >
      <Helmet>
        <title>
          {t('secureAddress.titleTag', {
            brokerName: BrokerName,
          })}
        </title>
      </Helmet>
      <HeadingSubtitle mb={12} color={themeColors.colorTextSecondary}>
        {t('addressDone.title')}
      </HeadingSubtitle>
      <Paragraph color={themeColors.colorTextXLLight}>
        {t('addressDone.subtitle')}
      </Paragraph>
      <OnBoardingCta
        onClick={() => {
          onSuccess();
        }}
        title={t('continue')}
        buttonProps={{
          'data-cy': 'button-continue',
        }}
      />
      {saveAndCloseModalOpen && (
        <SaveAndCloseModal
          isOpen={saveAndCloseModalOpen}
          onClose={() => setSaveAndCloseModalOpen(false)}
        />
      )}
    </OnBoardingContainer>
  );
};

export default AddressDone;
